import { render } from "./create.vue?vue&type=template&id=2711dd5e&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=2711dd5e&lang=scss&scoped=true"
import "./create.vue?vue&type=style&index=1&id=2711dd5e&lang=scss"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2711dd5e"]])

export default __exports__